
<modal
  :title="title"
  :open="open"
  size="full"
  @close="closeModal"
>
  <p class="description">
    {{ renderSubtitle }}
  </p>
  <form @submit.stop.prevent="submit">
    <text-input
      v-model.trim="name"
      label="Name"
    />

    <text-input
      v-model.trim="email"
      type="email"
      label="Email"
    />

    <text-area-input
      v-model="feedbackText"
      label="Comment"
    />

    <div class="button-row">
      <btn
        type="submit"
        :loading="submitting"
        :disabled="disabled"
        loading-text="Submitting"
      >
        Submit
      </btn>

      <btn kind="secondary" @click="closeModal">
        Cancel
      </btn>
    </div>
  </form>
</modal>
